import React from 'react';
import { RouteComponentProps } from '@reach/router';
import FullPage from '../../layouts/FullPage';

// TODO: Import components

interface IProjectCallListPageProps extends RouteComponentProps { }

interface IState { }

class ProjectCallListPage extends React.Component<IProjectCallListPageProps, IState> {
    // Define the constructor for the project call list page
    constructor (props: IProjectCallListPageProps) {
        // Pull in parent props
        super(props);
    }

    // TODO: When the component mounts
    componentDidMount () {
    }

    // Render the TSX for the project call list container
    render () {
        return (
            <FullPage>
                Project Call List page
            </FullPage>
        );
    }
}

export default ProjectCallListPage;
